define('ItemBadges.Model', [
    'Backbone.CachedModel',
    'underscore',
    'Utils'
], function ItemBadgesModel(
    CachedModel,
    _,
    Utils
) {
    'use strict';

    return CachedModel.extend({
        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('ItemBadges/services/ItemBadges.Service.ss')) // eslint-disable-line no-undef
    });
});
